/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const UnitRightIcon = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.9107 3.16107C7.23614 2.83563 7.76378 2.83563 8.08921 3.16107L14.3392 9.41107C14.6647 9.73651 14.6647 10.2641 14.3392 10.5896L8.08921 16.8396C7.76378 17.165 7.23614 17.165 6.9107 16.8396C6.58527 16.5141 6.58527 15.9865 6.9107 15.6611L12.5714 10.0003L6.9107 4.33958C6.58527 4.01414 6.58527 3.48651 6.9107 3.16107Z"
        fill="#898693"
      />
    </svg>
  )
}
